(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ap-dietro-le-quinte"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-behind-scenes')) {
    customElements.define('ap-behind-scenes', class extends HTMLElement {
      connectedCallback() {
        this._frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this._abort) return;
        this._video = this.querySelector('.ap-bts__video');
        if (!this._video) return;

        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._visible = false;
        this._pending = false;
        this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.removeAttribute('data-playing');

        // Nessun controllo: l'avvio automatico dipende dalla visibilita'.
        this._video.controls = false;
        this._video.removeAttribute('controls');
        this._video.autoplay = false;
        this._video.muted = true;
        this._video.defaultMuted = true;
        this._video.loop = true;
        this._video.playsInline = true;
        this._video.setAttribute('muted', '');
        this._video.setAttribute('playsinline', '');
        this._video.setAttribute('webkit-playsinline', '');
        this._video.setAttribute('tabindex', '-1');

        this._sync = () => this.syncPlayback();
        this._onPlaying = () => {
          if (this.shouldPlay()) this.setAttribute('data-playing', '');
          else this._video.pause();
        };
        this._video.addEventListener('playing', this._onPlaying, { signal });
        this._video.addEventListener('error', () => this.removeAttribute('data-playing'), { signal });
        document.addEventListener('visibilitychange', this._sync, { signal });
        window.addEventListener('pageshow', this._sync, { signal });

        // Riprova dopo una normale interazione, solo se il video e' visibile.
        document.addEventListener('pointerdown', this._sync, { signal, passive: true });
        document.addEventListener('keydown', this._sync, { signal });
        if (this._motion.addEventListener) this._motion.addEventListener('change', this._sync);
        else this._motion.addListener(this._sync);

        if ('IntersectionObserver' in window) {
          this._observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            this._visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
            this.syncPlayback();
          }, { threshold: [0, 0.15] });
          this._observer.observe(this.querySelector('.ap-bts__media'));
        } else {
          // Fallback per browser senza IntersectionObserver.
          this._checkViewport = () => {
            const rect = this.querySelector('.ap-bts__media').getBoundingClientRect();
            this._visible = rect.bottom > 0 && rect.top < window.innerHeight;
            this.syncPlayback();
          };
          window.addEventListener('scroll', this._checkViewport, { signal, passive: true });
          window.addEventListener('resize', this._checkViewport, { signal, passive: true });
          this._checkViewport();
        }
      }

      shouldPlay() {
        return this.isConnected && this._visible && !document.hidden && !this._motion.matches;
      }

      syncPlayback() {
        if (!this._video || !this._abort) return;
        if (!this.shouldPlay()) {
          this._video.pause();
          if (this._motion.matches) this.removeAttribute('data-playing');
          return;
        }
        this.startPlayback();
      }

      async startPlayback() {
        if (this._pending || !this._video.paused) return;
        const video = this._video;
        const signal = this._abort.signal;
        this._pending = true;
        video.muted = true;
        try {
          await video.play();
          if (signal.aborted || !this.shouldPlay()) video.pause();
        } catch (error) {
          // Autoplay bloccato o file non disponibile: resta la copertina.
          if (!signal.aborted) this.removeAttribute('data-playing');
        } finally {
          if (!signal.aborted) this._pending = false;
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this._frame);
        if (this._observer) this._observer.disconnect();
        if (this._abort) this._abort.abort();
        if (this._video) this._video.pause();
        if (this._motion && this._sync) {
          if (this._motion.removeEventListener) this._motion.removeEventListener('change', this._sync);
          else this._motion.removeListener(this._sync);
        }
        this._abort = null;
        this._observer = null;
        this._pending = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-risultati-reali"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ap-results-proof')) {
    customElements.define('ap-results-proof', class extends HTMLElement {
      connectedCallback() {
        this._frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (!this.isConnected || this._abort) return;

        this._media = this.querySelector('.ap-rp__media');
        this._video = this.querySelector('.ap-rp__video');
        if (!this._video || !this._media) return;

        this._abort = new AbortController();
        const signal = this._abort.signal;
        this._visible = false;
        this._pending = false;
        this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.removeAttribute('data-playing');

        this._video.controls = false;
        this._video.removeAttribute('controls');
        this._video.autoplay = false;
        this._video.muted = true;
        this._video.defaultMuted = true;
        this._video.loop = true;
        this._video.playsInline = true;
        this._video.preload = 'none';
        this._video.disablePictureInPicture = true;
        this._video.setAttribute('muted', '');
        this._video.setAttribute('playsinline', '');
        this._video.setAttribute('webkit-playsinline', '');
        this._video.setAttribute('disablepictureinpicture', '');
        this._video.setAttribute('disableremoteplayback', '');
        this._video.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
        this._video.setAttribute('tabindex', '-1');

        this._sync = () => this.syncPlayback();
        this._onPlaying = () => {
          if (this.shouldPlay()) this.setAttribute('data-playing', '');
          else this._video.pause();
        };

        this._video.addEventListener('playing', this._onPlaying, { signal });
        this._video.addEventListener('pause', () => {
          if (!this.shouldPlay()) this.removeAttribute('data-playing');
        }, { signal });
        this._video.addEventListener('ended', this._sync, { signal });
        this._video.addEventListener('error', () => this.removeAttribute('data-playing'), { signal });

        document.addEventListener('visibilitychange', this._sync, { signal });
        window.addEventListener('pageshow', this._sync, { signal });
        window.addEventListener('focus', this._sync, { signal });
        document.addEventListener('pointerdown', this._sync, { signal, passive: true });
        document.addEventListener('keydown', this._sync, { signal });

        if (this._motion.addEventListener) this._motion.addEventListener('change', this._sync);
        else this._motion.addListener(this._sync);

        if ('IntersectionObserver' in window) {
          this._observer = new IntersectionObserver((entries) => {
            const entry = entries[0];
            this._visible = entry.isIntersecting && entry.intersectionRatio >= 0.18;
            this.syncPlayback();
          }, { threshold: [0, 0.18, 0.4, 0.75] });
          this._observer.observe(this._media);
        } else {
          this._checkViewport = () => {
            const rect = this._media.getBoundingClientRect();
            this._visible = rect.bottom > 0 && rect.top < window.innerHeight * 0.9;
            this.syncPlayback();
          };
          window.addEventListener('scroll', this._checkViewport, { signal, passive: true });
          window.addEventListener('resize', this._checkViewport, { signal, passive: true });
          this._checkViewport();
        }
      }

      shouldPlay() {
        return this.isConnected && this._visible && !document.hidden && !this._motion.matches;
      }

      syncPlayback() {
        if (!this._video || !this._abort) return;

        if (!this.shouldPlay()) {
          this._video.pause();
          if (this._motion.matches) this.removeAttribute('data-playing');
          return;
        }

        this.startPlayback();
      }

      async startPlayback() {
        if (this._pending || !this._video.paused) return;

        const video = this._video;
        const signal = this._abort.signal;
        this._pending = true;
        video.muted = true;

        try {
          await video.play();
          if (signal.aborted || !this.shouldPlay()) video.pause();
        } catch (error) {
          if (!signal.aborted) this.removeAttribute('data-playing');
        } finally {
          if (!signal.aborted) this._pending = false;
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this._frame);
        if (this._observer) this._observer.disconnect();
        if (this._abort) this._abort.abort();
        if (this._video) this._video.pause();

        if (this._motion && this._sync) {
          if (this._motion.removeEventListener) this._motion.removeEventListener('change', this._sync);
          else this._motion.removeListener(this._sync);
        }

        this._abort = null;
        this._observer = null;
        this._pending = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
